import { LoaderFunctionArgs, replace } from 'react-router';

/** loader가 실제로 사용하는 필드만 받아, react-router 타입의 실험적 필드 추가에 영향을 받지 않도록 좁힌다. */
type RedirectLoaderArgs = Pick<LoaderFunctionArgs, 'params' | 'request'>;

/**
 * `/v2/:path*` → `/:path*`
 *
 * v2 prefix 뒤의 경로를 그대로 유지하며, query / hash도 함께 전달한다.
 */
export function v2PathRedirectLoader({ params, request }: RedirectLoaderArgs): Response {
  const rest = params['*'] ?? '';
  const url = new URL(request.url);
  return replace(`/${rest}${url.search}${url.hash}`);
}

/**
 * 고정 경로 → 고정 경로 리다이렉트 loader를 만든다.
 *
 * query / hash를 그대로 넘겨 `?drawer=`·필터·페이지 상태가 유지되게 한다.
 * 잘못된 URL이 히스토리에 남지 않도록 replace로 처리한다.
 *
 * 예: 메뉴 구조 변경으로 `/setting/branches` → `/branch-region/branches`
 */
export function createPathRedirectLoader(to: string) {
  return function pathRedirectLoader({ request }: Pick<RedirectLoaderArgs, 'request'>): Response {
    const url = new URL(request.url);
    return replace(`${to}${url.search}${url.hash}`);
  };
}
